import { css, cx, useTheme } from '@fable/theme'
import { useStats } from '../../../lib/ctx/stats'
import { MomBooksGridBookCover } from './MomBooksGridBookCover'
import { Ref, forwardRef } from 'react'
import { FlexBox, Text } from '@fable/components'
import { useMomBooksGrid } from './useMomBooksGrid'
import { useStatsPermission } from '../../../lib/hooks'
import { useStatsTheme } from '../../../theme/ctx'

interface Props {
  books: string[]
  max: number
}

const Content = ({ books, max }: Props, ref: Ref<HTMLDivElement>) => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const theme = useStatsTheme((s) => s.theme)
  const { isStatsOwner } = useStatsPermission()
  const { columnCount } = useMomBooksGrid()
  const bookCount = books.length
  const maxBookCount = bookCount > columnCount ? columnCount : bookCount
  const booksInMonth = bookCount ? books.slice(0, maxBookCount) : []
  const booksRemaining = bookCount - maxBookCount
  const booksLeft = booksRemaining > 0 ? booksRemaining : 0

  const hideBookCovers =
    !booksInMonth.length || (!isStatsOwner && stats?.is_finished_list_private)

  return (
    <div
      ref={ref}
      className={css`
        display: grid;
        grid-template-columns: repeat(${max}, 1fr);
        grid-auto-rows: 36px;
      `}
    >
      <div
        className={cx(
          'anim__mom-books-bar',
          'mom-books-content-bar',
          css`
            grid-column: span ${bookCount};
            background-color: ${theme.colors.primary};
            border-radius: 6px;
            position: relative;
            overflow: hidden;
            width: 0%;
            overflow: hidden;
            will-change: width;
          `
        )}
      >
        {!hideBookCovers ? (
          <div
            data-testid="mom-books-content-bar-books"
            className={cx(
              'anim__mom-books',
              'mom-books-content-bar-books',
              css`
                display: flex;
                position: absolute;
                right: ${booksLeft > 0 ? 4 : -4}px;
                bottom: -8px;
                opacity: 0;
                transform: translateY(20px);
                will-change: transform, opacity;
              `
            )}
          >
            {booksInMonth.map((coverImage, i) => (
              <MomBooksGridBookCover key={i} image={coverImage} />
            ))}
            {booksLeft === 0 ? null : (
              <FlexBox
                className={css`
                  margin-left: -4px;
                  margin-top: 0px;
                  width: 22px;
                  height: 36px;
                  background-color: ${colors.uiPearl};
                  border: 1px solid ${colors.uiPearlUltraLight};
                  border-radius: 4px;
                `}
                centerAll
              >
                <Text
                  className={css`
                    transform: translateY(-2.5px);
                  `}
                  type="label"
                  sizing="S"
                  weight="600"
                  color={colors.uiGraphite}
                >
                  +{booksLeft}
                </Text>
              </FlexBox>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export const MomBooksContentBar = forwardRef(Content)
